import {
  getApiV1ThreeLetterCodePartnerAdminsGroupsId,
  getGetApiV1ThreeLetterCodePartnerAdminsGroupsIdKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePartnerAdminsGroupsId200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  /** 3文字コード */
  threeLetterCode: string;
  /** グループID */
  groupId: number;
};

type ReturnType = {
  /** グループデータ */
  data: GetApiV1ThreeLetterCodePartnerAdminsGroupsId200;
  /** データ再取得関数 */
  mutate: () => void;
  /** ローディング状態 */
  isLoading: boolean;
};

/**
 * useGetPartnerAdminsGroupフックの型定義
 */
type IUseGetPartnerAdminsGroup = (args: Args) => ReturnType;

/**
 * パートナー管理者用グループ詳細取得フック
 */
export const useGetPartnerAdminsGroup: IUseGetPartnerAdminsGroup = ({
  threeLetterCode,
  groupId,
}) => {
  const { data, mutate, isLoading } = useFetch(
    getGetApiV1ThreeLetterCodePartnerAdminsGroupsIdKey(threeLetterCode, groupId),
    () => getApiV1ThreeLetterCodePartnerAdminsGroupsId(threeLetterCode, groupId),
    { suspense: true }
  );

  return {
    data,
    mutate,
    isLoading,
  };
};
